<div tabindex="0" role="alert" aria-describedby="alertText" class="toast-row flex justify-start content-start items-start flex-row">
    <div class="toast-icon-wrap">
        <mat-icon class="flex-1">{{data.panelType}}</mat-icon>
    </div>
    <div id="alertText" class="toast-message-wrap">
        <span [innerHTML]="data.message" class="toast-message-text m-l-8 m-r-10 flex flex-col" attr.aria-valuenow="{{data.message}}"></span>
    </div>
    <div class="toast-close-wrap">
        <button class="btn-transparent btn_icon m-t-3" (click)="close()" id="close" aria-label="Close button" type="button">
            <span class="svgicon icon_clear" aria-hidden="true"></span>
        </button>
    </div>
</div>
